import { Box, Paper, Typography } from '@mui/material'
import { StowageInstructionDto } from '@planning/app/api'
import { YesNoChipBox } from '@planning/components/dangerous-goods/YesNoChipBox'
import { StowageInstructionAutocompleteViewStore } from '@planning/stores/stowageInstruction/StowageInstructionAutocompleteViewStore'
import { useTranslate } from '@tolgee/react'
import { IFormStore, useRegisterSubFormStore } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { StowageInstructionSubFormStore } from '../stores/StowageInstructionsSubFormStore'
import { DirectionalCargoDetailsType } from './DirectionalCargoDetailsSubForm'
import { StowageInstructionsAutocomplete } from './StowageInstructionsAutocomplete'

export type StowageInstructionSubFormProps = {
  store: IFormStore<DirectionalCargoDetailsType>
  initialValues?: StowageInstructionDto | null
  autoCompleteStore: StowageInstructionAutocompleteViewStore
}

export const StowageInstructionsSubForm = observer(
  ({ store, initialValues, autoCompleteStore }: StowageInstructionSubFormProps) => {
    const { t } = useTranslate()
    const formStore = useRegisterSubFormStore(
      store,
      'stowageInstruction',
      new StowageInstructionSubFormStore(initialValues),
    )

    return (
      <Paper variant='outlined' sx={{ p: '1rem' }}>
        <Box display='flex' alignItems='center' justifyContent='space-between'>
          <Typography variant='body1' fontWeight='bold'>
            {t('stowageInstruction', 'Stowage instruction')}?
          </Typography>
          <YesNoChipBox
            activeOption={formStore.hasStowageInstruction.value ? 'Yes' : 'No'}
            onClickYes={() => formStore.hasStowageInstruction.setValue(true)}
            onClickNo={() => formStore.hasStowageInstruction.setValue(false)}
            dataCyYes='stowage-instruction-yes-chip'
          />
        </Box>
        {formStore.hasStowageInstruction.value && (
          <StowageInstructionsAutocomplete
            fieldStore={formStore.stowageInstruction}
            autoCompleteStore={autoCompleteStore}
          />
        )}
      </Paper>
    )
  },
)
